import logo from "../images/sidebarLogo.png";

export default {
  logo,
};
